<template>
  <div class="card">
    <div class="card-body text-center p-3">
      <div v-if="linkMessage !== undefined">
        {{linkMessage}}
      </div>
      <div v-else>
        <b-spinner size="sm"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>

export const APP_LINK_TO = {
  WORKSPACE: 'workspace',
  PROJECT_HOME: 'project',
  USER_PROFILE: 'user',
  JOB_DETAILS: 'job',
  ENTITY_DETAILS: 'entity',

  // others to be added as needed
};

export default {
  props: {
    to: {
      type: String,
      description: 'the link destination',
    },
    user: {
      type: String,
      description: 'the user id who opened the link from an external app',
    },
    workspace: {
      type: String,
      description: 'the workspace to link to',
    },
    project: {
      type: String,
      description: 'the project to link to',
    },
    job: {
      type: String,
      description: 'the job to link to',
    },
    entitySize: {
      type: String,
      description: 'the size of the entity to link to',
    },
    entityHash: {
      type: String,
      description: 'the hash of the entity to link to',
    },
    resourceSize: {
      type: String,
      description: 'the size of the resource to link to',
    },
    resourceHash: {
      type: String,
      description: 'the hash of the resource to link to',
    },
  },
  data() {
    return {
      linkMessage: undefined, // display error before redirect?
    };
  },
  created() {
    this.checkUserMatch();

    switch (this.$props.to) {
      case APP_LINK_TO.USER_PROFILE:
        this.rerouteToUser();
        break;
      case APP_LINK_TO.WORKSPACE:
        this.rerouteToWorkspace();
        break;
      case APP_LINK_TO.PROJECT_HOME:
        this.rerouteToProject();
        break;
      case APP_LINK_TO.JOB_DETAILS:
        this.rerouteToJob();
        break;
      case APP_LINK_TO.ENTITY_DETAILS:
        this.rerouteToEntity();
        break;
      default:
        this.rerouteToDefault();
    }
  },
  methods: {
    checkUserMatch() {
      const { user } = this.$auth;
      const authUser = user['https://api.imagineproducts.com/id'];
      const callingUser = this.$props.user;
      if (callingUser !== authUser) {
        console.info('APP LINK AUTH MISMATCH - auth user', authUser, '- route user', callingUser);
        // TODO: warn if the calling user is different than signed in user.
      }
    },
    rerouteToDefault() {
      // the route that will be fired if no others match.
      console.warn('APP LINK - bad destination - ROUTING DEFAULT');
      // TODO: show some sort of error message / countdown before redirect to tell the user the link failed.
      return this.$router.push({ path: '/' });
    },
    rerouteToUser() {
      /* demo link
      https://cloud.local.imagineproducts.com:1024/applink?to=user&user=NOTME
       */
      console.info('applink re-routing to user');
      return this.$router.push({ path: '/my/profile' });
    },
    rerouteToWorkspace() {
      /* demo link
      https://cloud.local.imagineproducts.com:1024/applink?to=workspace&workspace=1e03c440-b77e-42e2-8c93-c87503414749&user=NOTME
       */
      console.info('applink re-routing to workspace');
      const { workspace } = this.$props;
      if (!workspace) {
        console.warn('applink error - cannot link to account without workspace id');
        return this.rerouteToDefault();
      }
      return this.$router.push({ path: `/workspace/${workspace}` });
    },
    rerouteToProject() {
      /* demo link
      https://cloud.local.imagineproducts.com:1024/applink?to=project&project=89f4b17c-a1af-4573-b71f-c56a09e65d1c&user=NOTME
       */
      console.info('applink re-routing to project');
      const { project } = this.$props;
      if (!project) {
        console.warn('applink error - cannot link to project without project id');
        return this.rerouteToDefault();
      }
      return this.$router.push({ path: '/home', query: { project } });
    },
    rerouteToJob() {
      /* demo link
      https://cloud.local.imagineproducts.com:1024/applink?to=job&job=Uq2jRSxBTQHcGSF9qmTbtapHI66&project=89f4b17c-a1af-4573-b71f-c56a09e65d1c&user=NOTME
       */
      console.info('applink re-routing to job');
      const { project } = this.$props;
      if (!project) {
        console.warn('applink error - cannot link to job without project id');
        return this.rerouteToDefault();
      }
      const { job } = this.$props;
      if (!job) {
        console.warn('applink error - cannot link to job without job id - showing list instead');
        return this.$router.push({ path: '/jobs', query: { project } });
      }
      return this.$router.push({ path: `/jobs/${job}`, query: { project } });
    },
    rerouteToEntity() {
      /* demo link
      https://cloud.local.imagineproducts.com:1024/applink?to=entity&esize=23014356&ehash=1fdbc629d4674b42&project=234704dc-c772-40f8-a6b2-d6d94f9d0dbd&user=NOTME
       */
      console.info('applink re-routing to entity');
      const { project } = this.$props;
      if (!project) {
        console.warn('applink error - cannot link to entity without project id');
        return this.rerouteToDefault();
      }
      const { entitySize } = this.$props;
      if (!entitySize) {
        console.warn('applink error - cannot link to entity without entity-size for id');
        return this.rerouteToProject();
      }
      const { entityHash } = this.$props;
      if (!entityHash) {
        console.warn('applink error - cannot link to entity without entity-hash for id');
        return this.rerouteToProject();
      }
      return this.$router.push({ path: `/files/${entitySize}/${entityHash}`, query: { project } });
    },
  },
};
</script>

<style scoped>

</style>
